export default "/static/dashboard/build/app/img/v2/b7039b0a86218ba2be09964ed949e2e7.png";